<template>
  <div> 
    <v-card class="grey lighten-3">

    <v-flex xs12 lg6 class="ma-auto pa-3">
          <v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
     </v-flex>
      <v-data-table class="no-shadow card-r" v-bind:headers="headers"
                    v-bind:items="items" v-bind:search="search" v-bind:pagination="pagination" hide-actions>
        <template slot="headers" slot-scope="props">
          <tr>
            <th class="pa-2 f-12 font-weight-bold textColor" v-for="(header, index) in props.headers" :key="header.text"
                :class="['column', 'subheading' , index === 0? 'text-xs-left': 'text-xs-left']">
              {{ header.text }}
            </th>
            <th class="pa-2 f-12 text-xs-left font-weight-bold textColor"> Actions
            </th>
          </tr>
        </template>
        <template class="body-2" slot="items" slot-scope="props">
          <td class="pa-1" v-for="(header, index) in headers" :key="index"
               :class="[ index === 0? 'text-xs-left': 'text-xs-left', 'body-2']" v-if="header.value!==''">
            <div v-if="header.text=='Status'" class="tabel-slc">
              <v-select solo class="no-shadow"
                v-model="props.item.status"
                :items="clubStatus"
                item-text="props.item.status"
                item-value="props.item.status"
                @change=changestatus(props.item.admin_id,props.item.status)
                persistent-hint
                return-object
                single-line
              ></v-select>
            </div>
            <div v-if="header.text!='Status'">
              <div v-if="header.text=='Contact Number'">
                +45{{renderData(props.item, header)}}
              </div>
              <div v-if="header.text!='Contact Number'">
                {{renderData(props.item, header)}}
              </div>
            </div>

          </td>
          <td class="text-xs-left pa-0 layout px-0">
            <!-- <v-btn icon>
          <v-icon small  class="" @click.native="$emit('login',props.item.club_Id)">input</v-icon>
            </v-btn> -->
            <!--<v-btn icon @click.native="$emit('view',props.item.club_Id)">-->
            <v-btn small icon  @click.native="$emit('view',props.item.club_Id)">
              <v-icon class="f-15" color="green" to="/teacherprofile">fas fa-edit</v-icon>
            </v-btn>

            <v-btn small icon @click="setUserData(props.item)">
              <v-icon class="f-15" color="green">fas fa-sign-in-alt</v-icon> 
            </v-btn>

          </td>
        </template>
        <template slot="no-data">
     <span>
        <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Nothing to display here :(</p>
      </span>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2" v-if="isNotEmpty">
        <v-pagination v-model="pagination.page" :length="pagination.pages" :total-visible="5" circle></v-pagination>
      </div>
    </v-card>
    <v-dialog v-model="out" max-width="290">
      <v-card class="card-r">
        <v-card-title class="f-18 text-capitalize">Are You Sure Want To Login as "{{userData.schoolName}}" ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="grey text-white left card-r" text @click="closeout">No</v-btn>
          <v-btn class="primary text-white card-r" text @click="loginToAdmin(userData.admin_id)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable */
import api from "@/utils/backend-api"
import router from "@/router"
export default {
  props: {
    out: false,
    headers: '',
    items: '',
    item:'',
    pagination: '',
    page: 1,
    pages:'',
  },
  data () {
    return {
      search: "",
      item:'',
      clubStatus:['active','inactive'],
      userData:[]
      //selectedclubstatus:'active'
    }
  },
  methods: {
    setUserData(item){
      this.userData=item
      this.out=true
    },
    loginToAdmin(admin_id){
      console.log("loginToAdmin")
      console.log(admin_id)
      api.postData('driver/getAdminToken',{admin_id:admin_id})
      .then(res=>{
        if(res.status==201){
          // router.push(')
          window.open('https://admin.tittam.com/#/superlogin/'+admin_id+'/'+Store.state.token)
          this.out=false
          // window.open('https://admin.tittam.com/#/superlogin/'+admin_id+'/'+Store.state.token)
        }
      })

    },
    closeout(){
    this.out=false
    },
    renderData: (item, header) => {
      let val = "";
      if (header.value.includes('.')) {
        const vals = header.value.split('.')
        val = vals.reduce((acc, val) => acc[val], item)
      } else {
        val = item[header.value]
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    },

    changestatus(adminid,status){
      // if(status=="active"){
      //   status="inactive"
      // }else if(status=="inactive"){
      //   status="active"
      // }
      var Data={
        "adminid":adminid,
        "status":status
      }
      this.$store.dispatch("changeClubStatus", Data)

    },
  },
  computed: {
    isNotEmpty () {
      return this.items && this.items.length > 0;
    }
  }
}
</script>


<style>

.v-input{
  font-size:12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue